function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XS } from "constants/sizes";
import ProductSignUp from "segments/desktop/core-components/product-sign-up/product-sign-up";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, SERVICE_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { CRM_MINI_SITE_LINK, SERVICE_MINI_SITE_LINK, SOFTWARE_MINI_SITE_LINK, WORK_MANAGEMENT_MINI_SITE_LINK } from "constants/links";
import { StyledProductSignupButton } from "./product-signup-button.scss";
const PRODUCT_TO_MINI_SITE_URL = {
    [CRM_PRODUCT_ID]: CRM_MINI_SITE_LINK,
    [DEV_PRODUCT_ID]: SOFTWARE_MINI_SITE_LINK,
    [WORK_MANAGEMENT_PRODUCT_ID]: WORK_MANAGEMENT_MINI_SITE_LINK,
    [SERVICE_PRODUCT_ID]: SERVICE_MINI_SITE_LINK
};
const ProductSignupAndLearnMoreButtons = (_param)=>{
    var { translate, withArrow } = _param, button = _object_without_properties(_param, [
        "translate",
        "withArrow"
    ]);
    return /*#__PURE__*/ _jsxs(StyledProductSignupButton, {
        className: "product-signup-wrapper",
        children: [
            /*#__PURE__*/ _jsx(ProductSignUp, _object_spread_props(_object_spread({
                withButtonArrow: withArrow
            }, button), {
                buttonSize: XS
            })),
            /*#__PURE__*/ _jsx(SecondaryButton, {
                isWithArrow: withArrow,
                url: PRODUCT_TO_MINI_SITE_URL[button === null || button === void 0 ? void 0 : button.productType],
                color: button === null || button === void 0 ? void 0 : button.buttonColor,
                buttonText: translate("signup.learnMore"),
                isOpenLinkInNewTab: true
            })
        ]
    });
};
export default ProductSignupAndLearnMoreButtons;
